import { Box, Metadata, useTranslations } from "@bsm/component";
import { TUserParent } from "@bsm/graphql";

export const StudentDetailsParents = ({ parents }: { parents: TUserParent[] }) => {
    const [
        FAMILY_INFORMATION_DAD_TITLE,
        FAMILY_INFORMATION_MOTHER_TITLE,
        INFORMATION_NAME,
        COMPANY_NAME,
        COMPANY_POSITION,
    ] = useTranslations(i18nKeys);

    const title = {
        DAD: FAMILY_INFORMATION_DAD_TITLE,
        MOM: FAMILY_INFORMATION_MOTHER_TITLE,
    };

    const parentOrder = { DAD: 1, MOM: 2 };

    return (
    <div className="overflow-hidden rounded-3xl shadow bg-white">
        {
            parents?.sort((a, b) => parentOrder[a.parentType] - parentOrder[b.parentType]).map((parent) => (
                <Box title={title[parent.parentType]} className="flex flex-col gap-3 p-10">
                    <Metadata label={INFORMATION_NAME} value={parent?.user.fullName} />
                    <h3 className="mt-3">COMPANY</h3>
                    <Metadata label={COMPANY_NAME} value={parent?.company?.name} />
                    <Metadata label={COMPANY_POSITION} value={parent?.company?.position} />
                </Box>
            ))
        }
    </div>
    );
};

const i18nKeys = [
    "std_familyName_info.dad.title",
    "std_familyName_info.mother.title",
    "std_familyName_info.label",
    "std_info.company.name",
    "std_info.company.position",
    ];